module.exports = __webpack_public_path__ + "img/info_square.75627e34.svg";